import axios from '@/utils/request';

// 获取资源列表
export const getUserKnowledges = (data: any) => {
  return axios.request({
    url: 'UserKnowledge/GetUserKnowledges',
    method: 'GET',
    params: data,
  });
};

// 获取资源目录树
export const getCatalogTree = (data: any) => {
  return axios.request({
    url: 'UserKnowledge/GetCatalogTree',
    method: 'GET',
    params: data,
  });
};

// 获取资源详情
export const getUserKnowledgeDetails = (data: any) => {
  return axios.request({
    url: 'UserKnowledge/GetUserKnowledgeDetails',
    method: 'GET',
    params: data,
  });
};

// 获取资源详情
export const postUserKnowledge = (data: any) => {
  return axios.request({
    url: 'UserKnowledge/PostUserKnowledge',
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'POST',
    data,
  });
};

// 获取相关资源
export const getRelatedUserKnowledges = (data: any) => {
  return axios.request({
    url: 'UserKnowledge/GetRelatedUserKnowledges',
    method: 'GET',
    params: data,
  });
};
